<template>
  <p class="m-2 breadcrumb" v-html="title"/>
</template>

<script>

export default {
  name: "Breadcrumb",
  components: {
  },
  props: {
    title: String
  },
  mounted () {
    this.title = this.title || this.$t('titulo')
    let r = this.title.split('>').slice(-1)[0]
    window.document.title = this.$t('titulo') + ' - ' + r
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
